const mapByKey = (arr, key = 'id', transform = a => a) =>
  arr.reduce((result, obj) => Object.assign(result, { [obj[key]]: transform(obj) }), {});

export default mapByKey;